<template class="template-public-part">
    <div class="public-part">
        <div class="content">
            <div class="left-nav">
                <ul>
                    <li :class="{'active':currentNav=='edit'}" @click="navJump('edit')">
                        <router-link :to="{path:'/PublicPart/EditLanguage',query:{projectId:projectId,projectName:projectName}}">
                            <img :class="{'active':currentNav=='edit'}" type="edit" style="width:22px" src="../../assets/img/liucheng.svg" alt="">
                            <div>流程节点</div>
                        </router-link>
                    </li>
                    <li :class="{'active':currentNav=='sync'}" @click="navJump('sync')">
                        <router-link :to="{path:'/PublicPart/DiscreteNode',query:{projectId:projectId,projectName:projectName}}">
                            <img :class="{'active':currentNav=='sync'}" style="width:26px" src="../../assets/img/lisan.svg" alt="">
                            <div>离散节点</div>
                        </router-link>
                    </li> 
                    <li :class="{'active':currentNav=='api'}" @click="navJump('api')">
                        <router-link :to="{path:'/PublicPart/IntentionTrain',query:{projectId:projectId,projectName:projectName}}">
                            <img :class="{'active':currentNav=='api'}" style="width:30px" src="../../assets/img/yitu.svg" alt="">
                            <div>意图训练</div>
                        </router-link>
                    </li>
                    <li :class="{'active':currentNav=='colors'}" @click="navJump('colors')"> 
                        <router-link :to="{path:'/PublicPart/ProjectLines',query:{projectId:projectId,projectName:projectName}}">
                            <img :class="{'active':currentNav=='colors'}" style="width:25px" src="../../assets/img/taici.svg" alt="">
                            <div>台词录音</div>
                        </router-link>
                    </li>
                    <!-- <li :class="{'active':currentNav=='details'}">
                        <router-link :to="{path:'/Dialogues',query:{projectId:projectId,projectName:projectName}}">
                            <img style="width:25px" src="../../assets/img/shuju.svg" alt="">
                            <div>数据详情</div>
                        </router-link>
                    </li> -->
                </ul>
            </div>
            <div class="right-content">
                <router-view></router-view>
            </div>
        </div>
        <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
           <a-icon style="z-index:1000;font-size:25px" type="message" />
        </router-link> -->
    </div>
</template>
<script>
export default {
    name: 'PublicPart',
    props: {
        msg: String
    },
    data() {
        return {
            navListColor: [true, false, false],
            currentNav: '',
            projectId: null,
            projectName: ''
        };
    },
    methods: {
        navJump(type){
            this.currentNav = type
        },
    },
    created() {
        this.projectId = this.$route.query.projectId
    },
    mounted: function() {
        this.currentNav = sessionStorage.getItem('contentNavItem')
        window.addEventListener('setItem', ()=> {
            this.projectName = sessionStorage.getItem('projectName')
        })
        if(this.$route.query.projectName != undefined){
            this.projectName = this.$route.query.projectName
        }
    }
}
</script>
<style scoped  lang="less">
    .public-part{
        height: 100%;
        .head{
            background: #fff;
            z-index: 100;
            height: 48px;
            position: fixed;
            top: 0px;
            width: 100%;
            font-size: 14px;
            box-shadow: 3px -1px 9px 2px;
            color: rgba(80, 80, 80, 1);
            text-align: center;
            .left{
                float: left;
            }
            .back{
                margin: 10px 18px 0;
                font-size: 25px;
                color:rgba(19, 194, 194, 1)
            }
            .title{
                font-size: 14px;
                color: rgba(80, 80, 80, 1);
                line-height: 48px;
                font-size: 16px;
                font-weight: bold;
            }
            .head-nav{
                display:inline-block;
                span{
                    margin: 0 5px;
                    line-height: 48px;
                }
            }
            a{
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
        }
        .content{
            // padding-top: 48px;
            height: 100%;
            .left-nav{
                position: fixed;
                height: 100%;
                width: 64px;
                background: rgba(34, 215, 187, 1);
                color: #fff;
                text-align: center;
                // padding-top: 30px;
                li{
                    display: inline-block;
                    width: 100%;
                    height:64px;
                    a{
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                    }
                    img{
                        display: block;
                        transition: all  0.25s  ease-in;
                        margin: 22px auto 0;
                    }
                    div{
                        font-size: 12px;
                        display: none;
                        transition: all  0.5s  ease-in;
                    }
                    a{
                        color: #fff;
                        font-size: 24px;
                    }
                }
                li.active{
                    background: rgba(0, 183, 154, 1);
                }
                li:hover{
                    div{
                        display: block;
                        transform:translateY(-4px);
                    }
                    img{
                        transform:translateY(-10px);
                    }
                }
            }
            .right-content{
                width: 100%;
                padding-left: 64px;
                height: 100%;
                // box-shadow: 0px 0px 1px #000 !important;
            }
        }
    }
</style>
